import React,{useState,useEffect, Children} from 'react';

function Tooltip({ children, message }) {
  const [show, setShow] = useState(false);

  return (
    <div
      className="relative inline-block"
      onMouseEnter={() => setShow(true)}
      onMouseLeave={() => setShow(false)}
    >
      {children}
      {show && (
        <div>
          {message}
        </div>
      )}
    </div>
  );
}

export default Tooltip;